export function getRandomItems(arr: any[], numItems: number) {
  let arrayCopy = [...arr];
  let randomItems = [];
  
  for (let i = 0; i < numItems; i++) {
    let randomIndex = Math.floor(Math.random() * arrayCopy.length);
    randomItems.push(arrayCopy[randomIndex]);
    arrayCopy.splice(randomIndex, 1);
  }
  
  return randomItems;
}
